/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h3[_ngcontent-%COMP%]{color:#394042;font-size:20px;margin-top:30px;margin-bottom:15px}.no-margin-top[_ngcontent-%COMP%]{margin-top:0}p[_ngcontent-%COMP%]{max-width:1000px}"];
export { styles as styles };
